import { eachDayOfInterval, format } from "date-fns";

export default (start: Date, end: Date) => {
  return eachDayOfInterval({
    start,
    end,
  }).map((d) => format(d, "EEEE").toLowerCase());
};
